import React from 'react';
import PropTypes from 'prop-types';

export default class ErrorBoundary extends React.Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    errorHandler: PropTypes.func,
  };

  static defaultProps = {
    errorHandler: null,
  };

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, info) {
    const { children = { } } = this.props;
    const childCompName = children.type && children.type.displayName;

    // doing this the quick & dirty way because we shouldn't be logging very much
    // throughout our app, and using other methods loses context of line numbers
    // eslint-disable-next-line no-console
    if (typeof console !== 'undefined' && typeof console.error === 'function') {
      // eslint-disable-next-line no-console
      console.error(`error in component: ${childCompName}`, error, info);
    }

    this.setState({ hasError: true });
  }

  render() {
    const { hasError } = this.state;
    const { children, errorHandler } = this.props;

    if (hasError) {
      if (errorHandler) {
        return errorHandler();
      }
      return null;
    }

    return children;
  }
}
